/* tslint:disable */
require('./FieldRenderer.module.css');
const styles = {
  ellipsis: 'ellipsis_8a544fb6',
  relative: 'relative_8a544fb6',
  fabricIcon: 'fabricIcon_8a544fb6',
};

export default styles;
/* tslint:enable */